/**
 * Whether the main pointer is a finger, so focusing a text field brings up
 * the on-screen keyboard. False where the browser cannot say (jsdom has no
 * `matchMedia`).
 */
export const isTouchScreen = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
  && window.matchMedia('(pointer: coarse)').matches;
